import { useContractNewProducts } from '@/Contract/ui/context'
import { LogaltyIframe } from '@/Logalty/ui/organisms'
import { ProtectedWrapper } from '@/Shared/ui/navigation'

export const ContractNewProductsStep4 = (): JSX.Element => {
  const {
    logalty: { logalty },
    nextStep,
  } = useContractNewProducts()

  return (
    <ProtectedWrapper>
      <LogaltyIframe logalty={logalty} callback={nextStep} />
    </ProtectedWrapper>
  )
}
